import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Load Stripe outside of component to avoid recreating on every render
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeProvider = ({ children }) => {
  if (!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
    return (
      <div className="text-center p-6 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded">
        <p className="font-medium">Configuration Stripe manquante</p>
        <p className="text-sm">Veuillez configurer REACT_APP_STRIPE_PUBLISHABLE_KEY dans votre fichier .env</p>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
